import React from "react";
import { Link } from "react-router-dom";
import { Counter } from "../Essentials/WebCounter";
import {
  FacebookFilled,
  MailFilled,
} from "@ant-design/icons";

const NAVY      = "#1A2B4A";
const NAVY_DEEP = "#0F1D36";
const NAVY_BAR  = "#080F1E";
const GOLD      = "#C8991A";
const GOLD_SOFT = "#E0B948";
const CRIMSON   = "#B22222";
const TEXT      = "rgba(255,255,255,0.78)";
const TEXT_DIM  = "rgba(255,255,255,0.55)";
const BORDER    = "rgba(200,153,26,0.18)";

const statutory = [
  { label: "Gauhati University", href: "https://www.gauhati.ac.in/" },
  { label: "RUSA",   href: "http://rusa.nic.in/" },
  { label: "UGC",    href: "https://www.ugc.ac.in/" },
  { label: "DHE",    href: "https://dheonlineadmission.amtron.in/sp/" },
  { label: "NAAC",   href: "http://naac.gov.in/index.php/en/" },
  { label: "KKHSOU", href: "http://www.kkhsou.in/web_new/" },
  { label: "IGNOU",  href: "http://www.ignou.ac.in/" },
  { label: "GUCDOE", href: "http://www.gucdoe.in/" },
];

const portals = [
  { label: "Admission Portal",    href: "http://admission.rangiacollege.ac.in/" },
  { label: "Teacher's Portal",    href: "http://user.rangiacollege.ac.in/" },
  { label: "Student's Portal",    href: "http://student.rangiacollege.ac.in/" },
  { label: "DHE Unique ID Portal", href: "https://dheonlineadmission.amtron.in/sp/" },
  { label: "GU Portal",           href: "https://guportal.in/" },
];

const quickLinks = [
  { label: "Recruitment",        to: "/recruitment" },
  { label: "NIRF",               to: "/nirf" },
  { label: "RTI",                to: "/rti/home" },
  { label: "RTI Officers",       to: "/rti/officers" },
  { label: "Tender",             to: "/notifications/tender" },
  { label: "Documents Gallery",  to: "/gallery/document" },
  { label: "Photo Gallery",      to: "/gallery/photo" },
  { label: "Video Gallery",      to: "/gallery/video" },
  { label: "Grievance Redressal", href: "http://grievance.rangiacollege.ac.in/" },
];

const information = [
  { label: "Contact Us",            to: "/contactus" },
  { label: "Exam Results",          to: "/students/results" },
  { label: "Class Routines",        to: "/students/routines" },
  { label: "Exam Schedules",        to: "/students/exam-schedule" },
  { label: "Downloads",             to: "/students/downloads" },
  { label: "Important Information", to: "/importantfile" },
];

function FooterLink({ to, href, label }) {
  if (to) {
    return (
      <li className="pf-li">
        <Link to={to} className="pf-link">
          <span className="pf-link__chev" aria-hidden="true">›</span>
          {label}
        </Link>
      </li>
    );
  }
  return (
    <li className="pf-li">
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="pf-link"
      >
        <span className="pf-link__chev" aria-hidden="true">›</span>
        {label}
      </a>
    </li>
  );
}

function FooterColumn({ heading, items }) {
  return (
    <div className="pf-col">
      <h4 className="pf-heading">
        {heading}
        <span className="pf-heading__rule" />
      </h4>
      <ul className="pf-list">
        {items.map((it, i) => (
          <FooterLink key={i} {...it} />
        ))}
      </ul>
    </div>
  );
}

export default function PanduFooter() {
  return (
    <footer className="pf">
      {/* Brand strip */}
      <div className="pf-brandstrip">
        <div className="pf-brandstrip__inner">
          <div className="pf-brandstrip__left">
            <img
              src="/images/rc-logo.png"
              alt="Rangia College logo"
              className="pf-brandstrip__logo"
            />
            <div>
              <div className="pf-brandstrip__name">Rangia College</div>
              <div className="pf-brandstrip__tag">
                Kamrup, Assam · Affiliated to Gauhati University · Est. 1963
              </div>
            </div>
          </div>
          <div className="pf-brandstrip__right">
            <a
              href="https://www.facebook.com/rangiacollege"
              target="_blank"
              rel="noopener noreferrer"
              className="pf-social"
              aria-label="Facebook"
            >
              <FacebookFilled style={{ fontSize: 18 }} />
            </a>
            <a
              href="mailto:principal@rangiacollege.ac.in"
              className="pf-social"
              aria-label="Email"
            >
              <MailFilled style={{ fontSize: 18 }} />
            </a>
          </div>
        </div>
      </div>

      {/* Main columns */}
      <div className="pf-main">
        <div className="pf-grid">
          <FooterColumn heading="Statutory Bodies" items={statutory} />
          <FooterColumn heading="Admission & Portals" items={portals} />
          <FooterColumn heading="Quick Links" items={quickLinks} />
          <FooterColumn heading="Information" items={information} />
        </div>

        {/* CONTACT band */}
        <div className="pf-divider">
          <span className="pf-divider__label">Contact</span>
        </div>

        <div className="pf-grid pf-grid--3">
          <div className="pf-col">
            <h4 className="pf-heading">
              Office Address
              <span className="pf-heading__rule" />
            </h4>
            <address className="pf-address">
              Principal, Rangia College<br />
              Rangia, Kamrup &mdash; 781354<br />
              Assam (India)<br /><br />
              <a href="mailto:principal@rangiacollege.ac.in" className="pf-inline">
                principal@rangiacollege.ac.in
              </a>
            </address>
          </div>

          <div className="pf-col">
            <h4 className="pf-heading">
              RTI (Appellate Authority)
              <span className="pf-heading__rule" />
            </h4>
            <div className="pf-rti-block">
              <div className="pf-rti-label">Appellate Authority</div>
              Dr. Brajendra Saikia<br />
              <span className="pf-muted">Principal</span><br />
              <a href="mailto:principal@rangiacollege.ac.in" className="pf-inline">
                principal@rangiacollege.ac.in
              </a>
            </div>
            <div className="pf-rti-block">
              <div className="pf-rti-label">First Information Officer</div>
              Principal<br />
              <a href="mailto:principal@rangiacollege.ac.in" className="pf-inline">
                principal@rangiacollege.ac.in
              </a>
            </div>
            <div className="pf-rti-block">
              <div className="pf-rti-label">Second Information Officer</div>
              Principal<br />
              <span className="pf-muted">Assistant Professor</span><br />
              <a href="mailto:principal@rangiacollege.ac.in" className="pf-inline">
                principal@rangiacollege.ac.in
              </a>
            </div>
          </div>

          <div className="pf-col">
            <h4 className="pf-heading">
              Page Statistics
              <span className="pf-heading__rule" />
            </h4>
            <div className="pf-counter">
              <Counter />
            </div>
            <Link to="/visitors-note" className="pf-visitors">
              Visitor&apos;s Note
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="pf-bottom">
        <div className="pf-bottom__inner">
          <div className="pf-bottom__left">
            © {new Date().getFullYear()} Rangia College. All rights reserved.
          </div>
          <div className="pf-bottom__right">
            Designed &amp; Developed with <span style={{ color: CRIMSON }}>&#x2764;</span> by Corexx
          </div>
        </div>
      </div>

      <style>{`
        .pf {
          background: ${NAVY_DEEP};
          color: ${TEXT};
          font-family: 'Lato', sans-serif;
          font-size: 13.5px;
          line-height: 1.55;
        }
        .pf a { text-decoration: none; }

        /* ── Brand strip ── */
        .pf-brandstrip {
          background: linear-gradient(90deg, ${NAVY} 0%, #21345c 100%);
          border-top: 3px solid ${GOLD};
          border-bottom: 1px solid ${BORDER};
        }
        .pf-brandstrip__inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 20px 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 24px;
          flex-wrap: wrap;
        }
        .pf-brandstrip__left {
          display: flex;
          align-items: center;
          gap: 16px;
        }
        .pf-brandstrip__logo {
          height: 56px;
          width: auto;
          object-fit: contain;
        }
        .pf-brandstrip__name {
          font-family: 'Playfair Display', Georgia, serif;
          font-size: 22px;
          font-weight: 700;
          color: #fff;
          letter-spacing: 0.3px;
        }
        .pf-brandstrip__tag {
          font-size: 11.5px;
          color: ${TEXT_DIM};
          letter-spacing: 0.4px;
          margin-top: 2px;
        }
        .pf-brandstrip__right {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .pf-social {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          border: 1px solid ${BORDER};
          color: ${GOLD};
          display: inline-flex;
          align-items: center;
          justify-content: center;
          transition: background 0.18s, color 0.18s, transform 0.18s, border-color 0.18s;
        }
        .pf-social:hover {
          background: ${GOLD};
          color: ${NAVY_DEEP};
          border-color: ${GOLD};
          transform: translateY(-1px);
        }

        /* ── Main columns ── */
        .pf-main {
          max-width: 1200px;
          margin: 0 auto;
          padding: 36px 24px 24px;
        }
        .pf-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 28px;
        }
        .pf-grid--3 {
          grid-template-columns: repeat(3, 1fr);
        }
        .pf-col { min-width: 0; }
        .pf-heading {
          color: #fff;
          font-family: 'Lato', sans-serif;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 1.6px;
          text-transform: uppercase;
          margin: 0 0 14px;
          position: relative;
          padding-bottom: 10px;
        }
        .pf-heading__rule {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 36px;
          height: 2px;
          background: ${GOLD};
          border-radius: 2px;
        }
        .pf-list {
          list-style: none;
          margin: 0;
          padding: 0;
        }
        .pf-li { margin: 0; }
        .pf-link {
          display: flex;
          align-items: baseline;
          gap: 6px;
          color: ${TEXT};
          padding: 4px 0;
          font-size: 13px;
          transition: color 0.15s, padding-left 0.15s;
        }
        .pf-link__chev {
          color: ${GOLD};
          font-weight: 700;
          flex-shrink: 0;
          transition: transform 0.15s;
          display: inline-block;
        }
        .pf-link:hover {
          color: ${GOLD_SOFT};
          padding-left: 3px;
        }
        .pf-link:hover .pf-link__chev {
          transform: translateX(2px);
        }

        /* ── Divider band ── */
        .pf-divider {
          position: relative;
          margin: 36px 0 28px;
          text-align: left;
        }
        .pf-divider::before {
          content: "";
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          height: 1px;
          background: ${BORDER};
        }
        .pf-divider__label {
          position: relative;
          display: inline-block;
          background: ${NAVY_DEEP};
          padding-right: 14px;
          color: ${GOLD};
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 3px;
          text-transform: uppercase;
        }

        /* ── Address & RTI ── */
        .pf-address {
          font-style: normal;
          color: ${TEXT};
          font-size: 13px;
          margin: 0;
        }
        .pf-rti-block {
          margin-bottom: 14px;
          font-size: 13px;
        }
        .pf-rti-label {
          color: ${GOLD};
          font-size: 10.5px;
          font-weight: 700;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          margin-bottom: 2px;
        }
        .pf-muted { color: ${TEXT_DIM}; }
        .pf-inline {
          color: ${GOLD_SOFT};
          transition: color 0.15s;
        }
        .pf-inline:hover { color: #fff; }

        /* ── Counter & Visitor's note ── */
        .pf-counter {
          color: ${TEXT};
          font-size: 12px;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          margin-bottom: 18px;
        }
        .pf-counter > div > div {
          color: #fff;
          font-family: 'Playfair Display', Georgia, serif;
          font-size: 26px !important;
          font-weight: 700;
          margin-top: 4px;
          letter-spacing: 0.5px;
        }
        .pf-visitors {
          display: inline-block;
          padding: 8px 18px;
          color: ${GOLD};
          border: 1px solid ${GOLD};
          font-size: 11.5px;
          font-weight: 700;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          border-radius: 3px;
          transition: background 0.18s, color 0.18s;
        }
        .pf-visitors:hover {
          background: ${GOLD};
          color: ${NAVY_DEEP};
        }

        /* ── Bottom bar ── */
        .pf-bottom {
          background: ${NAVY_BAR};
          border-top: 1px solid ${BORDER};
        }
        .pf-bottom__inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 14px 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 8px;
          color: ${TEXT_DIM};
          font-size: 12px;
        }

        @media (max-width: 960px) {
          .pf-grid { grid-template-columns: repeat(2, 1fr); }
          .pf-grid--3 { grid-template-columns: 1fr; }
        }
        @media (max-width: 560px) {
          .pf-grid { grid-template-columns: 1fr; }
          .pf-brandstrip__inner { justify-content: center; text-align: center; }
          .pf-brandstrip__left { flex-direction: column; text-align: center; }
          .pf-bottom__inner { justify-content: center; text-align: center; }
        }
      `}</style>
    </footer>
  );
}
